import React, { Component } from 'react';
import Config from "../../config";
import Styles from "../../styles/Styles";

export default class Header extends Component {
  constructor(props) {
   super(props);

    this.state = {
    };
  }

  render() {

    return (
      <header style={Styles.Style.bgColorSecondary} className="heading-secondary">
        <div className="text-box">
          <h1>Programme {Config.program.programName}</h1>
            <p className="margin-bottom-m">Fidélisation et différenciation en pharmacie</p>
          <button className="btn btn-lg btn-secondary" onClick={this.props.onButtonClicked}>Fidéliser votre clientèle</button>
        </div> 
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SellingPage/Header.js